/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsShiftStatusInput } from "../../entities/models/ShiftStatusInput";
import { z } from "zod/v4";

export const modelsShiftStatusInputSchema = z.object({
    "status": z.enum(["free", "busy", "break"])
    }) as unknown as z.ZodType<ModelsShiftStatusInput>